const curry = [
  {
    title: 'Meals',
    price: 'Rs 90',
  },
  {
    title: 'Chala ',
    price: 'Rs 90',
  },
  {
    title: 'Ayla ',
    price: 'Rs 100',
  },
  {
    title: 'Karimeen',
    price: 'Rs 300',
  },
  {
    title: 'Neymeen',
    price: 'Rs 400',
  },
];

const Tawa = [
  {
    title: 'Naymeen ',
    price: 'Rs 400',
  },
  {
    title: "Karimeen",
    price: 'Rs 300',
  },
  {
    title: 'Chemmeen',
    price: 'Rs 300',
  },
  {
    title: 'Tiger Prawns ',
    price: 'Rs 350',
  },
  {
    title: 'Prawns Fry',
    price: 'Rs 300',
  },
];

const data = { curry, Tawa };

export { curry, Tawa };
export default data;
